var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconColorinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7276B0F0-B397-404B-AE26-ECAF0DAE6C37@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Link-Donor-to-CRM---Donor-Not-Found",
    transform: "translate(-1008.000000, -343.000000)",
    fill: "#D0021B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(993.000000, 323.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Round-/-Alert-/-error",
    transform: "translate(15.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.48,0 0,4.48 0,10 C0,15.52 4.48,20 10,20 C15.52,20 20,15.52 20,10 C20,4.48 15.52,0 10,0 Z M10,11 C9.45,11 9,10.55 9,10 L9,6 C9,5.45 9.45,5 10,5 C10.55,5 11,5.45 11,6 L11,10 C11,10.55 10.55,11 10,11 Z M11,15 L9,15 L9,13 L11,13 L11,15 Z",
    id: "\\uD83D\\uDD39Icon-Color"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColorinfo);
export default __webpack_public_path__ + "static/media/iconColorinfo.4f66691a6ee10c448f4c2a3292b2809b.svg";
export { ForwardRef as ReactComponent };